// extracted by mini-css-extract-plugin
export var bodySections = "_bw-8";
export var gray = "_bw-7";
export var green = "_bw-4";
export var iconContainer = "_bw-9";
export var iconWidgetContainer = "_bw-1";
export var phoneIcon = "_bw-2";
export var red = "_bw-5";
export var statusDot = "_bw-3";
export var widgetContainer = "_bw-0";
export var yellow = "_bw-6";